/**
 * Maps agent error codes to localized panel copy (FEAT-1698).
 *
 * platform-api error messages (`{ error: { code, message } }` and the SSE `error` event) are plain
 * English operator text produced by `ApiError`/zod — they are not localized and must never be
 * rendered. The stable `code` is the localization key instead. GraphQL mint failures are the one
 * exception: `AgentDelegationGraphqlErrors` builds those messages through the request locale, so
 * they arrive already localized and are rendered verbatim.
 */

/** Fallback copy for codes with no dedicated message. */
export const AGENT_ERROR_GENERIC_KEY = 'hiring-dashboard-ai-assistant:agent.error.generic';

const AGENT_ERROR_MESSAGE_KEYS = {
  NOT_IMPLEMENTED: 'hiring-dashboard-ai-assistant:agent.error.unavailable',
  UPSTREAM_TIMEOUT: 'hiring-dashboard-ai-assistant:agent.error.timeout',
  CONFLICT: 'hiring-dashboard-ai-assistant:agent.error.busy',
  ABORTED: 'hiring-dashboard-ai-assistant:agent.error.stopped',
  RATE_LIMITED: 'hiring-dashboard-ai-assistant:agent.error.rateLimited',
  VALIDATION_FAILED: 'hiring-dashboard-ai-assistant:agent.error.invalidMessage',
  PAYLOAD_TOO_LARGE: 'hiring-dashboard-ai-assistant:agent.error.invalidMessage',
  UNAUTHENTICATED: 'hiring-dashboard-ai-assistant:agent.error.permission',
  INSUFFICIENT_SCOPE: 'hiring-dashboard-ai-assistant:agent.error.permission',
  PERMISSION_DENIED: 'hiring-dashboard-ai-assistant:agent.error.permission',
} as const satisfies Record<string, string>;

/** Returns the localization key for an agent error code, falling back to generic copy. */
export function agentErrorMessageKey(code: string): string {
  return AGENT_ERROR_MESSAGE_KEYS[code] ?? AGENT_ERROR_GENERIC_KEY;
}
